// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3V1Zz","title":"BackImages_title__1Mhp8","images":"BackImages_images__3LzHD"};